module.exports = __webpack_public_path__ + "public/media/creator-vector1.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/creator-vector1.png
// module id = ./images/services/creator-vector1.png
// module chunks = 0